import * as React from 'react';
import { BaseComponent } from '../../BaseComponent';
import { LayoutType } from '../../../constants/LayoutConstants';

import core = egr.wcf.core;
import { PropertyItem } from './PropertyItem';

export interface PropertyClassProps extends React.Props<PropertyClass> {
    layoutType: LayoutType;
    properties: Array<core.prop.Property>;
    propertyClassName: string | null;
    property?: core.prop.Property;
    choiceList?: Array<core.prop.PropertyValue>;
}

export interface PropertyClassState {
    open: boolean;
}

/*
    Child of PropertyEditor-Component
    */
export class PropertyClass extends BaseComponent<PropertyClassProps, PropertyClassState> {
    public componentWillMount(): void {
        this.setState({open: true});
    }

    public render(): JSX.Element {
        const tPropertyItems: Array<JSX.Element> = new Array();
        for (let j: number = 0; j < this.props.properties.length; j++) {
            const tActive: boolean = (
                this.props.property != null &&
                this.props.properties[j] != null &&
                this.props.property.key === this.props.properties[j].key
            );
            tPropertyItems.push(
                <PropertyItem
                    active={tActive}
                    choiceList={tActive ? this.props.choiceList : undefined}
                    key={j}
                    layoutType={this.props.layoutType}
                    property={this.props.properties[j]}
                />
            );
        }
        return (
            <div className={'core-config' + (this.state.open ? ' active' : '')}>
                <div className="core-config-header" onClick={this.toggle}>{this.props.propertyClassName}</div>
                <div className="core-config-items">{tPropertyItems}</div>
            </div>
        );
    }

    protected toggle = (): void => {
        this.setState({open: !this.state.open});
    };

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/sidebar/propertyeditor/PropertyClass.tsx